/**
 * NOAA Fishing Closed Areas data layer.
 * Syncs from layout so layer shows when provided in initialLayers even before tab is opened.
 */
import React, { useLayoutEffect, useRef } from 'react';
import type { RegistryComponentProps } from '../../../pages/registry/componentRegistry';
import { useDataLayer } from '../hooks/useDataLayer';

export default function NoaaFishingClosedAreasDataLayer(
  props: RegistryComponentProps
): React.ReactElement {
  const { slug, isReady, isActive, setActive, mapController } = useDataLayer(
    props
  );
  const syncedFromLayoutRef = useRef(false);

  // When layer is in layout, mapController has it active but our isActive may not have synced yet.
  useLayoutEffect(() => {
    if (syncedFromLayoutRef.current || !setActive || !mapController?.isReady())
      return;
    if (mapController.isLayerActive(slug) && !isActive) {
      setActive(true);
      syncedFromLayoutRef.current = true;
    }
  }, [slug, isActive, setActive, mapController]);

  return (
    <div className="control-section">
      <div className="section-title">
        <span className="section-icon">NOAA Fishing Closed Areas</span>
      </div>
      <div
        style={{
          fontSize: '12px',
          color: '#6c757d',
          marginBottom: '12px',
          fontStyle: 'italic',
        }}
      >
        Fishing closure areas including year-round closures, habitat
        protection, and cod protection zones
      </div>
      <div className="form-group">
        <label
          className="checkbox-label"
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        >
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setActive(e.target.checked)
            }
            disabled={!isReady}
            style={{ marginRight: '8px' }}
          />
          <span>Show NOAA Fishing Closed Areas</span>
        </label>
      </div>
    </div>
  );
}
